import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientHeadController_SaveStatus_Input_Status,
  useLegalClientBeneficiarySaveStatusMutation,
} from 'api/generated/graphql';
import { parseLegalClientBeneficiaryEntity, useError } from 'api/helpers';

interface Props {
  versionNumber: number;
  reason: string;
}

export const useLegalClientBeneficiaryArchive = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBeneficiarySaveStatusMutation();

  const error = useError(apolloError);

  return {
    legalClientBeneficiary: data?.saveStatus
      ? parseLegalClientBeneficiaryEntity(data.saveStatus)
      : undefined,
    loading,
    error,
    archive: useCallback(
      async (id: string, { reason, versionNumber }: Props) => {
        const res = await handle({
          variables: {
            id,
            input: {
              reason,
              versionNumber,
              status:
                MutationInput_LegalClientHeadController_SaveStatus_Input_Status.Archived,
            },
          },
        });
        return res.data?.saveStatus
          ? parseLegalClientBeneficiaryEntity(res.data?.saveStatus)
          : undefined;
      },
      [handle]
    ),
  };
};
